import React from 'react';
import './SprintResults.css';
import { tTeamMember } from '../data/Team';
import { eFeedbackCondition, sprintRetroFeedback, tSprintRetroFeedback } from '../data/SprintReviewFeedback';
import { tIssue } from '../data/Issues';

interface SprintResultsModalProps {
  isOpen: boolean;
  completedStoryPoints: number;
  totalStoryPoints: number;
  issues: tIssue[];
  team: tTeamMember[];
  closeModal: (localTeam: tTeamMember[]) => void;
}

export default function SprintResultsModal(props: SprintResultsModalProps) {
  console.log('SprintResultsModal, team', props.team);
  const completedStoryPointsPercentage = Math.round((props.completedStoryPoints / props.totalStoryPoints) * 100);
  let localTeam: tTeamMember[] = structuredClone(props.team);
 
  function getFeedback(member: tTeamMember) {
    let membersPersonalSP = 0;
  
    // Calculate personal story points for the developer (dev) or QA (member 4)
    for (let issue of props.issues) {
      if (issue.dev === member.id) {
        membersPersonalSP += issue.storyPoints;
      }
    }
  
    if (member.id === 4) {  // Special case for QA
      for (let issue of props.issues) {
        if (issue.qa === member.id) {
          membersPersonalSP += issue.storyPoints;
        }
      }
    }
  
    // Function to check if the feedback is valid based on the condition
    const isValidFeedback = (randomFeedback: tSprintRetroFeedback) => {
      if (randomFeedback.condition === eFeedbackCondition.random) {
        return true;
      }
      if (randomFeedback.condition === eFeedbackCondition.equals && completedStoryPointsPercentage === randomFeedback.value) {
        return true;
      }
      if (randomFeedback.condition === eFeedbackCondition.lessThan && completedStoryPointsPercentage < randomFeedback.value) {
        return true;
      }
      if (randomFeedback.condition === eFeedbackCondition.greaterThan && completedStoryPointsPercentage > randomFeedback.value) {
        return true;
      }
      if (randomFeedback.condition === eFeedbackCondition.between && completedStoryPointsPercentage > randomFeedback.value && completedStoryPointsPercentage < randomFeedback.value + 10) {
        return true;
      }
      if (randomFeedback.condition === eFeedbackCondition.personalGreaterThan && membersPersonalSP > randomFeedback.value) {
        return true;
      }
      if (randomFeedback.condition === eFeedbackCondition.personalLessThan && membersPersonalSP < randomFeedback.value) {
        return true;
      }
      if (randomFeedback.condition === eFeedbackCondition.personalBetween && membersPersonalSP > randomFeedback.value && membersPersonalSP < randomFeedback.value + 2) {
        return true;
      }
      return false;
    };
  
    // Try the first time to find valid feedback
    let randomFeedback = sprintRetroFeedback[Math.floor(Math.random() * sprintRetroFeedback.length)];
    if (isValidFeedback(randomFeedback)) {
      if (randomFeedback.impact !== 0){
        let newMember = localTeam.find((m: tTeamMember) => m.id === member.id);
        if (newMember) {
          console.log('newMember', newMember);
          console.log('newTeams', localTeam);
          newMember.level += randomFeedback.impact;
        }
      }
      return (<p>{member.icon} 💬 {randomFeedback.text} {randomFeedback.impact > 0 ? '⬆️' : randomFeedback.impact < 0 ? '⬇️' : null}</p>);
    }
  
    // Try the second time if no valid feedback was found
    randomFeedback = sprintRetroFeedback[Math.floor(Math.random() * sprintRetroFeedback.length)];
    if (isValidFeedback(randomFeedback)) {
      if (randomFeedback.impact !== 0){
        let newMember = localTeam.find((m: tTeamMember) => m.id === member.id);
        if (newMember) {
          newMember.level += randomFeedback.impact;
        }
      }
      return (<p>{member.icon} 💬 {randomFeedback.text} {randomFeedback.impact > 0 ? '⬆️' : randomFeedback.impact < 0 ? '⬇️' : null}</p>);
    }
  
    // If no valid feedback was found in both attempts, return null
    return null;
  }
  

  return (
    <div className={`modal ${props.isOpen ? 'open' : ''}`}>
      <div className="modal-content">
        <h2>Sprint Results</h2>
        <div className="sprint-review">
          <h3>Sprint Review</h3>
          <p>
            Total Story Points: {props.totalStoryPoints}<br />
            Completed Story Points: {props.completedStoryPoints}<br />
            Progress: {Math.round((props.completedStoryPoints / props.totalStoryPoints) * 100)}%
          </p>
        </div>

        <div className="sprint-retrospective">
          <h3>Sprint Retrospective</h3>
          <div>
            {localTeam.map((member) => (
              getFeedback(member)
            ))}
          </div>
        </div>

        <button onClick={() => props.closeModal(localTeam)}>Close</button>
      </div>
    </div>
  );
};


